<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-success m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10"></div>
              <h3 class="h4">Request Treatment (Out-of-State)</h3>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row list">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="row card-body">
                  <div class="form-group col-md-6">
                    <label for="inputCity"
                      >Select Enrollee State<span class="text-danger"
                        >*</span
                      ></label
                    >
                    <select
                      class="form-control"
                      required
                      v-model="transfer.my_state"
                      @change="fetchLga"
                    >
                      <option
                        :value="state"
                        v-for="state in states"
                        :key="state"
                      >
                        {{ state.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputCity">Search Enrollee</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Insurance ID/NIN"
                      v-model="searchkey"
                      @change="searchIDCard"
                    />
                  </div>

                  <div class="form-group col-md-12">
                    <button
                      class="btn btn-success btn-block"
                      @click="searchIDCard"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
              <div class="card m-b-30" v-show="userDetails">
                <form @submit.prevent="AddDisease">
                  <div class="card-body">
                    <div class="form-row">
                      <div class="col-md-6 offset-md-3 my-6">
                        <img
                          :src="`https://claimify-api.hayokmedicare.ng/image/${selected_enrollee.user_image}`"
                          class="img"
                          alt="User Photo"
                          onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
                        />
                      </div>
                      <div class="form-group col-md-12">
                        <label for="inputCity">Enrollee Name (SHIA ID)</label>
                        <input
                          type="text"
                          class="form-control"
                          id="inputEmail4"
                          :value="
                            selected_enrollee.full_name +
                            ` ` +
                            `(${selected_enrollee.id_card_number})`
                          "
                          disabled
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Sector</label>
                        <input
                          type="text"
                          class="form-control"
                          id="inputEmail4"
                          :value="selected_enrollee.sector"
                          disabled
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity"
                          >Select State<span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="transfer.state"
                          @change="fetchLga"
                        >
                          <option
                            :value="state"
                            v-for="state in states"
                            :key="state"
                          >
                            {{ state.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity"
                          >LGA <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="transfer.localgovt"
                          @change="getProvidersByLGAs"
                        >
                          <option
                            v-for="lga in lga_states"
                            v-bind:key="lga"
                            :value="lga.id"
                          >
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label
                          >Proposed Facility Enrollee wants to Access Care
                        </label>
                        <v-select
                          v-model="referred_to_facility"
                          label="agency_name"
                          :options="providers"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="inputCity">
                          Short description of how the enrollee is feeling
                          currently?</label
                        >
                        <textarea
                          name=""
                          rows="2"
                          class="form-control"
                          v-model="comments[0].body"
                          required
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-success btn-block" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      isLoading: false,
      fullPage: true,
      userDetails: false,
      selected_enrollee: {},
      searchkey: "",
      lga_states: "",
      referred_to_facility: "",
      comments: [
        {
          body: "Hello",
        },
      ],
      states: [
        {
          state_id: 2669,
          name: "Kogi State (KGSHIA)",
          agency_id: 90,
        },
        {
          state_id: 2676,
          name: "Osun State (OSHIA)",
          agency_id: 95930,
        },
        {
          state_id: 2679,
          name: "Rivers State (RIVCHPP)",
          agency_id: 407465,
        },
        {
          state_id: 2679,
          name: "Zamfara State (ZAMCHEMA)",
          agency_id: 4,
        },
      ],
      transfer: {
        my_state: "",
        state: "",
        localgovt: "",
        reason_for_change: "",
        client_id: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    //
  },
  methods: {
    clearIt() {
      this.transfer.reason_for_change = "";
      this.transfer.new_health_facility = "";
      this.transfer.previous_health_facility = "";
      this.transfer.status = "";
      this.transfer.prepared_by = "";
      this.searchkey = "";
      this.enrollee_details = "";
    },

    searchIDCard() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/searchenrollees`, {
          agency_id: this.transfer.my_state.agency_id,
          request_query: this.searchkey,
        })
        .then((response) => {
          this.selected_enrollee = response.data[0];
          this.userDetails = true;

          this.isLoading = false;
        })
        .catch((error) => {
          this.loading = false;

          console.error(error);
          this.isLoading = false;
          this.$toasted.info("User not Found", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
    fetchLga() {
      this.isLoading = true;

      this.axios
        .get(`/api/v1/auth/lga/${this.transfer.state.state_id}`)
        .then((response) => {
          this.lga_states = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    getProvidersByLGAs() {
      this.isLoading = true;

      this.axios
        .get(
          `/api/v1/auth/providerAgencies/${this.transfer.state.agency_id}/${this.transfer.localgovt}`
        )
        .then((response) => {
          this.providers = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    AddDisease() {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/authorization_code", {
          agency_id: this.selected_enrollee.agency_id,
          principal_id:
            this.selected_enrollee.type == "client"
              ? this.selected_enrollee.id
              : 0,
          dependent_id:
            this.selected_enrollee.type == "Dependent"
              ? this.selected_enrollee.id
              : 0,
          provider_id: 0,
          is_corridor: true,
          service_summary_id: 0,
          referred_to_facility: this.referred_to_facility.id,
          comments: this.comments,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Successful!", {
            position: "top-center",
            duration: 3000,
          });

          //   this.clearIt();
          //   this.sendSMS();
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$toasted.error("Not Added!", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
  },
  created() {
    // this.getProviders();
  },
};
</script>
  
  <style scoped>
.notice {
  padding: 2rem;
  text-align: center;
}

.notice__heading {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.note__content {
  font-size: 1rem;
}
</style>
  